/**
 * Inspector i18next Configuration
 *
 * Delegates to @rtvloco/platform/i18n for initialization.
 * Exports SUPPORTED_LOCALES and ALL_NAMESPACES for use by LanguageSwitcher
 * and other components that need to enumerate locale or namespace options.
 *
 * Locale files live at public/locales/{locale}/{namespace}.json
 */

import i18next from 'i18next';
import { initI18n } from '@rtvloco/platform/i18n';
import { STORAGE_KEY_LOCALE } from '../config/constants';

export const SUPPORTED_LOCALES = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'es-PE', label: 'Spanish (Peru)', nativeLabel: 'Español (PE)' },
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]['code'];

export const ALL_NAMESPACES = [
  'common',
  'nav',
  'auth',
  'inspector',
  'validation',
] as const;

export type I18nNamespace = (typeof ALL_NAMESPACES)[number];

// Clear any stored locale that is no longer supported before init
const storedLocale = localStorage.getItem(STORAGE_KEY_LOCALE);
if (
  storedLocale &&
  !SUPPORTED_LOCALES.map((l) => l.code).includes(storedLocale as SupportedLocale)
) {
  localStorage.removeItem(STORAGE_KEY_LOCALE);
}

void initI18n({
  locales: ['en', 'es-PE'],
  defaultLocale: 'en',
  backend: 'http',
  translationsPath: '/locales/{{lng}}/{{ns}}.json',
  namespaces: [...ALL_NAMESPACES] as string[],
  storageKey: STORAGE_KEY_LOCALE,
});

export default i18next;
